import {Column, ListTable} from "../list-table";
import {OrganizationAddressCell} from "../list-table/OrganizationAddressCell";
import {StatusCell, TextCell} from "../list-table/SharedCells";
import {ContactCell} from "../list-table/ContactCell";
import {RoleNameEnum} from "../../utils/types/common";
import {SSOBadge} from "../list-table/SSOBadge";
import {Tooltip, NavLink} from "@reside/ui";
import {AdminRoles} from "../admin-roles";

export function AdminOrganizationsTable(props) {
  return (
    <ListTable
      key={props.tableName}
      data={props.organizations}
      getRowId={row => row.rowData.id}
      showDoubleArrowOnNotSorted
      sortPredicates={{
        name: ["name"],
        address: [
          "address.number",
          "address.street",
          "address.city",
          "address.state.abbreviation",
          "address.zip",
        ],
        contact: ["phone", "email"],
        status: ["status"],
      }}
      sortBy="name"
      sortDirection="ASC"
      onRowClick={props.onRowClick}
    >
      <Column
        cellRenderer={row => <TextCell>{row.rowData.name}</TextCell>}
        label="Name"
        sortKey="name"
        width={180}
      />
      <Column
        cellRenderer={row => (
          <OrganizationAddressCell data={row.rowData.address} />
        )}
        label="Address"
        sortKey="address"
        width={200}
      />
      <Column
        cellRenderer={row => (
          <>
            <AdminRoles roles={[RoleNameEnum.ORGANIZATION_ADMIN]}>
              <NavLink
                to={
                  row.rowData.hasSsoConfig.ssoEntryExists
                    ? `/admin/organizations/${row.rowData.id}/sso-configuration`
                    : `/admin/organizations/${row.rowData.id}/sso-configuration/create`
                }
                onClick={e => e.stopPropagation()}
              >
                <SSOBadge
                  label={
                    row.rowData.hasSsoConfig.ssoEntryExists
                      ? "SSO configured"
                      : "SSO not configured"
                  }
                />
              </NavLink>
            </AdminRoles>
            <AdminRoles roles={[RoleNameEnum.RESIDE_ADMIN]}>
              <Tooltip
                content={
                  row.rowData.hasSsoConfig.ssoEntryExists
                    ? "SSO is configured with this client"
                    : "SSO is yet to be configured with this client"
                }
              >
                <SSOBadge
                  label={
                    row.rowData.hasSsoConfig.ssoEntryExists
                      ? "SSO configured"
                      : "SSO not configured"
                  }
                />
              </Tooltip>
            </AdminRoles>
          </>
        )}
        label="SSO"
        width={200}
      />
      <Column
        cellRenderer={row => <StatusCell data={row.rowData.status} />}
        label="Status"
        sortKey="status"
        width={150}
      />
      <Column
        cellRenderer={row => <ContactCell data={row.rowData} />}
        label="Contact"
        sortKey="contact"
        width={250}
      />
    </ListTable>
  );
}
